import get from 'lodash.get';

const getPrivacyPolicyURL = (rootState) =>
  get(rootState, 'partner.properties.privacyPolicyUrl', null);

export default getPrivacyPolicyURL;
